import * as React from "react";

// When the popup is closed, Base UI's ComboboxInput onKeyDown handler clears
// both the typed input value and the committed selection on Escape (an
// ARIA-permitted but destructive interpretation of the combobox pattern). We
// suppress that path by stopping the synthetic event in capture phase before
// it reaches the input's React bubble-phase handler. The popup-open Escape
// (handled by Base UI's document listener in useDismiss) and the parent
// Modal/Dialog Escape (handled by Radix's document-capture listener, which
// runs before any React synthetic dispatch) are both unaffected.
export function useSuppressEscapeClear(open: boolean) {
  return React.useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === "Escape" && !open) {
        event.stopPropagation();
      }
    },
    [open]
  );
}
